import { FC } from 'react';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InvoicePaymentReceiptPreview from '../../pages/Invoice/InvoicePaymentReceiptPreview';

interface IPaymentReceiptDrawerProps {
  open: boolean;
  onClose: () => void;
  /** Invoice the payment was applied to; its receipt is what gets previewed. */
  invoiceId?: string;
  templateId?: string;
  /** 'AR' for payments in, 'AP' for payments out. */
  type: 'AR' | 'AP';
}

/**
 * The existing payment receipt page, shown in a right-side drawer so the payments list stays in place.
 */
const PaymentReceiptDrawer: FC<IPaymentReceiptDrawerProps> = ({ open, onClose, invoiceId, templateId, type }) => (
  <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: { xs: '100%', lg: '85vw' }, maxWidth: '100%' } }}>
    <Box sx={{ display: 'flex', alignItems: 'center', px: 3, py: 1.25, bgcolor: '#e9ecf1', borderBottom: '1px solid #dcdcdc' }}>
      <Typography sx={{ flex: 1, fontWeight: 600, fontSize: '17px', color: '#1a1a1a' }}>Payment Receipt</Typography>
      <IconButton size="small" onClick={onClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
    {open && invoiceId && (
      <InvoicePaymentReceiptPreview
        key={invoiceId}
        invoiceId={invoiceId}
        templateId={templateId}
        type={type}
        embedded
      />
    )}
  </Drawer>
);

export default PaymentReceiptDrawer;
